import { createRouter, createWebHashHistory } from "vue-router";

const routes = [{
        path: "/",
        redirect: "/privacy",
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import("../views/privacy/index.vue"),
    },
    {
        path: "/contract",
        name: "contract",
        component: () => import("../views/contract/index.vue"),
    },
    {
        path: "/copyright",
        name: "copyright",
        component: () => import("../views/copyright/index.vue"),
    },
    {
        path: "/distributor",
        name: "distributor",
        component: () => import("../views/distributor/index.vue"),
    },

];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
});

export default router;